export class ConfigService {
    private static _config = {
      UNITY_API_DOMAIN: 'https://gateway.unitydev.ca',
      // MINDSCOPE_API_DOMAIN: 'https://unitystart-mindscope-api.unitydev.ca',
      HOST_API_DOMAIN: '',
      INTEGRATION_V1_API_BASE: '/IntegrationService/api/v1',
      INTEGRATION_V2_API_BASE: '/IntegrationService/api/v2',
      SECURITY_SERVICE_V1_API_BASE: '/SecurityService/api/v1',
      TENANT_V2_API_BASE: '/TenantService/api/v2',
      V1_API_BASE: '/api/v1',
    };
  
    private static _isConfigSet = false;
    private static _configPromise: Promise<void>;
    private static _resolveConfigPromise: () => void;
  
    static {
      this._configPromise = new Promise<void>(resolve => {
        this._resolveConfigPromise = resolve;
      });
    }
  
    static set config(config: {
      UNITY_API_DOMAIN?: string;
      INTEGRATION_V1_API_BASE?: string;
      INTEGRATION_V2_API_BASE?: string;
      SECURITY_SERVICE_V1_API_BASE?: string;
      TENANT_V2_API_BASE?: string;
      HOST_API_DOMAIN?: string;
      V1_API_BASE?: string;
    }) {
      console.log('Current config:', this._config);
      console.log('New config:', config);
      this._config = { ...this._config, ...config };
      console.log('Updated config:', this._config);
      this._isConfigSet = true;
      this._resolveConfigPromise();
    }
  
    static get config() {
      return this._config;
    }
  
    static async waitForConfig() {
      if (!this._isConfigSet) {
        await this._configPromise;
      }
    }
  }